import axios from "axios";
import { NotImplementedError } from "../../errors";
import { PromiseHandler } from "../../handlers";
import { GenreContentObjectsFetchFailed } from "./errors";
export class GenreContentObjects extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "contentObjects.genre", { atomize: true });
        this.url = `${this.sdk.urls.baseAPIUrl}/genres`;
    }
    /* Finds and retrieves items based on the provided filters.
     *
     * @param filters - The filters to apply when searching for `GenreContent` items.
     *           Supports:
     *             {FilterTypes.EQ, "subGenresOf"}
     *             {FilterTypes.EQ, "PrimaryGenresOnly"}
     * @throws FiltersRequiredError - If the provided filters do not include an ID filter.
     */
    findItems(filters) {
        const url = new URL(this.url);
        const subGenresOf = filters.where?.find((filter) => filter.field === "subGenresOf")?.value;
        if (subGenresOf) {
            url.searchParams.append("sub_genres_of", JSON.stringify(subGenresOf));
        }
        const primaryGenresOnly = filters.where
            ?.find((filter) => filter.field === "primaryGenresOnly")
            ?.value.toString();
        if (primaryGenresOnly === "true") {
            url.searchParams.append("primary_genres_only", "true");
        }
        else if (primaryGenresOnly === "false") {
            url.searchParams.append("primary_genres_only", "false");
        }
        const finalUrl = url.toString();
        return this.cache.promise(finalUrl, () => axios
            .get(finalUrl, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(({ data: res }) => res?.data?.map(this.toGenre) || [])
            .catch((error) => {
            throw new GenreContentObjectsFetchFailed(error);
        }));
    }
    /**
     * @deprecated
     * Genres does not support save.
     */
    saveItem() {
        return new Promise((_, reject) => {
            reject(new NotImplementedError("save"));
        });
    }
    /**
     * Converts from a service Genre to a client Genre.
     * @param genre: the Genre to convert.
     * @return: the converted Genre.
     */
    toGenre(genre) {
        const { name, parent } = genre;
        return { name, parent };
    }
    /**
     * @deprecated
     * Genres does not support make.
     */
    make() {
        return new Promise((_, reject) => {
            reject(new NotImplementedError("make"));
        });
    }
    async deleteItem() {
        return new Promise((_, reject) => {
            reject(new NotImplementedError("delete"));
        });
    }
}
//# sourceMappingURL=genre.js.map